import http from '../../../http/base';
import { API_PATHS } from '../../../http/configs';

export function getVoucherPrograms(partnerId) {
    return http.get(API_PATHS.getVoucherPrograms, { params: { partnerId } });
}
